/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapporten_Config_Elements_SportdeelnameInputs */

const nl_rapporten_config_elements_sportdeelname = /** @type {(inputs: Rapporten_Config_Elements_SportdeelnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sportdeelname`)
};

/**

* @param {Rapporten_Config_Elements_SportdeelnameInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const rapporten_config_elements_sportdeelname = /** @type {((inputs?: Rapporten_Config_Elements_SportdeelnameInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapporten_Config_Elements_SportdeelnameInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_rapporten_config_elements_sportdeelname(inputs)
});
export { rapporten_config_elements_sportdeelname as "rapporten.config.elements.sportdeelname" }